import { render, staticRenderFns } from "./FormControlMProductsProductsCategoryId.vue?vue&type=template&id=70566690"
import script from "./FormControlMProductsProductsCategoryId.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlMProductsProductsCategoryId.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports